/** Service Desk console: calibrated categorization (M29-K-05; CRM-001, CRM-003): the chip, the Needs category view and the accuracy report. */
export const serviceCategorization = {
  tabs: { accuracy: "Category accuracy" },
  banner: {
    on: {
      title: "Categories are applied by themselves",
      body: "A category is applied only when the assistant and this workspace's model agree and the score is at least {{threshold}}. Everything else waits for a person in Needs category.",
    },
    off_insufficient_data: {
      title: "Categories are not applied by themselves yet",
      body: "Sagot needs at least {{min}} tickets whose category your team chose; this workspace has {{count}}. Until then every new ticket waits in Needs category for a person.",
    },
    off_by_setting: {
      title: "Applying categories by themselves is switched off",
      body: "Every new ticket waits in Needs category for a person. Switch it on in the accuracy report.",
    },
    noModel: "No model has been trained yet. It trains overnight, or press Retrain now in the accuracy report.",
    open: "Open the accuracy report",
  },
  needs: {
    title: "Needs category",
    subtitle: "Open tickets whose category nobody has settled yet, with the suggestion and its score.",
    link: "Needs category",
    back: "All tickets",
    list: "Tickets that need a category",
    suggested: "Suggested: {{category}} ({{score}})",
    suggestedNoScore: "Suggested: {{category}} (no score yet)",
    choose: "Category of {{number}}",
    confirm: "Confirm",
    set: "Set category",
    done: "{{number}} is now {{category}}.",
    more: "Showing {{shown}} of {{total}} tickets.",
    error: "The tickets could not be loaded",
    errorHint: "Check your connection and try again.",
    retry: "Try again",
    empty: {
      title: "Nothing needs a category",
      hint: "Every open ticket has a category that was applied by itself or settled by your team.",
      cta: "Back to tickets",
    },
  },
  chip: {
    applied: "applied",
    review: "needs review",
    agent: "set by agent",
    customer: "set by customer",
    meter: "Score of {{name}}",
    thresholdMark: "Threshold {{threshold}}",
    threshold: "Threshold {{threshold}}, set from {{count}} past tickets.",
    change: "Change",
  },
  accuracy: {
    window: "The last six months, by calendar month. Precision is the share of categories applied by themselves that nobody had to correct.",
    needs: "Needs category",
    csv: "Download CSV",
    error: "The accuracy report could not be loaded",
    errorHint: "Check your connection and try again.",
    empty: {
      title: "No categorized tickets yet",
      hint: "Once new tickets are categorized, their precision, coverage and corrections appear here by month.",
    },
    tiles: {
      labelled: "Labelled tickets",
      labelledHint: "Auto-apply needs {{min}}",
      threshold: "Calibrated threshold",
      thresholdHint: "Chosen for {{target}} precision",
      precision: "Precision",
      coverage: "Coverage",
      corrections: "Corrections",
      noMonth: "No month yet",
    },
    model: {
      title: "Model",
      retrain: "Retrain now",
      queued: "Retraining started. It usually takes a minute.",
      none: "No model has been trained yet.",
      training: "Training version {{version}}...",
      failed: "The last training could not run: {{count}} labelled tickets were not enough. The previous model stays in use.",
      active: "Version {{version}}, learned from {{count}} tickets on {{when}}; {{precision}} precise on held-out tickets.",
      monthly: "The model retrains by itself every month.",
    },
    settings: {
      title: "Settings",
      auto: "Apply categories by themselves",
      autoHint: "Stays off below {{min}} labelled tickets whatever this says.",
      target: "Target precision",
      targetHint: "The threshold is chosen so this share of what is applied by itself is right on held-out tickets.",
      save: "Save settings",
      saved: "Settings saved.",
      readOnly: "Only members who can configure tickets change these.",
    },
    months: { title: "By month", month: "Month", precision: "Precision", coverage: "Coverage", corrections: "Corrections" },
    byCategory: { title: "By category", month: "Month", category: "Category" },
  },
} as const;
